/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-tracker
 * Portfolio-tracker
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    InvestownMonthlyStatusDto,
    InvestownMonthlyStatusDtoFromJSON,
    InvestownMonthlyStatusDtoFromJSONTyped,
    InvestownMonthlyStatusDtoToJSON,
} from './InvestownMonthlyStatusDto';

/**
 * 
 * @export
 * @interface InvestownMonthlyStatusListDto
 */
export interface InvestownMonthlyStatusListDto {
    /**
     * 
     * @type {number}
     * @memberof InvestownMonthlyStatusListDto
     */
    total: number;
    /**
     * 
     * @type {number}
     * @memberof InvestownMonthlyStatusListDto
     */
    limit: number;
    /**
     * 
     * @type {number}
     * @memberof InvestownMonthlyStatusListDto
     */
    offset: number;
    /**
     * 
     * @type {Array<InvestownMonthlyStatusDto>}
     * @memberof InvestownMonthlyStatusListDto
     */
    items: Array<InvestownMonthlyStatusDto>;
}

export function InvestownMonthlyStatusListDtoFromJSON(json: any): InvestownMonthlyStatusListDto {
    return InvestownMonthlyStatusListDtoFromJSONTyped(json, false);
}

export function InvestownMonthlyStatusListDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): InvestownMonthlyStatusListDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'total': json['total'],
        'limit': json['limit'],
        'offset': json['offset'],
        'items': ((json['items'] as Array<any>).map(InvestownMonthlyStatusDtoFromJSON)),
    };
}

export function InvestownMonthlyStatusListDtoToJSON(value?: InvestownMonthlyStatusListDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'total': value.total,
        'limit': value.limit,
        'offset': value.offset,
        'items': ((value.items as Array<any>).map(InvestownMonthlyStatusDtoToJSON)),
    };
}

